// src/service/ApiService.js
import axios from "axios";



const BASE_BCL_URL = process.env.REACT_APP_LOGIN_API_BASE_URL;
const BASE_DecToken_URL = process.env.REACT_APP_DECODE_API_URL;



///new FTApi via middle layer
export async function SaveNGetFtInfo(payload) {
  try {
    const response = await axios.post(
      `${BASE_BCL_URL}/SaveInvestorAndGetToken`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const {
      Fyn_Status,
      Fyn_Token,
      Fyn_RedirectUrl,
      Fyn_ExpiredAt,
      SignUp_Required,
    } = response.data.body;

    return {
      Fyn_Status,
      Fyn_Token,
      Fyn_RedirectUrl,
      Fyn_ExpiredAt,
      SignUp_Required,
    };
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
}


////
export async function decodeToken(token) {
  if (!token) {
    throw new Error("Token is required");
  }

  const payload = { token };

  try {
    const response = await axios.post(`${BASE_DecToken_URL}/decode-token`, payload, {
      headers: { "Content-Type": "application/json" },
      validateStatus: () => true,
    });

    // ✅ Return both data and status
    return {
      status: response.status,
      data: response.data,
    };

  } catch (error) {
    // If axios itself fails (e.g. network error)
    console.error("❌ Decode API Error:", error);

    return {
      status: error.response ? error.response.status : 500,
      data: error.response ? error.response.data : error.message,
    };
  }
}
